export default "__VITE_ASSET__b24c913b__"